import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import * as styles from './mobile-header.module.scss'

const MobileHeader = ({
    logo,
    items
}) => {
    const scrollTo = (id) => {
        document.getElementById('naviToggle').checked = false;
        if (document.getElementById(`${id}`))
            window.scrollTo({
                top: document.getElementById(`${id}`).offsetTop - 80,
                behavior: "smooth",
            })
    }

    return (
        <div>
            <div className={styles.container}>
                <div className={styles.headerContainer}>
                    <GatsbyImage
                        image={logo.gatsbyImageData}
                        alt={logo.title}
                        className={styles.logo}
                        objectFit="contain"
                        onClick={e => scrollTo('home-content')}
                    />
                    <input
                        type="checkbox"
                        id="naviToggle"
                        className={styles.navigation__checkbox}
                        hidden
                    />
                    <label
                        htmlFor="naviToggle"
                        className={styles.navigation__button}
                    >
                        <span className={styles.navigation__icon}>&nbsp;</span>
                    </label>
                </div>
            </div>
            <ul className={styles.navMenu}>
                {
                    items.map(({ slug, title }, index) => {
                        return (
                            <li
                                key={index}
                                className={styles.headerItem}
                                onClick={e => scrollTo(slug.replace('#', ''))}
                            >{title}</li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default MobileHeader